import { atom } from 'jotai';

import { itemAliasUpdateAtom } from '../_graphql/mutationItemAliasUpdate';
import { itemAliasDetailQueryAtom } from '../_graphql/queryItemAliasDetail';

import { settingsRouteParamAtom } from './settingsModule.state';

// 🟣🟣🟣 PARAMS
export const $itemAliasId = settingsRouteParamAtom(
  ['/inventory/item-aliases/:id'],
  'id',
);

// 🟢🟢🟢 REMOTE DATA
export const $remoteItemAliasDetail = itemAliasDetailQueryAtom((get) => {
  const itemAliasId = get($itemAliasId);
  return {
    variables: {
      ids: itemAliasId ? [itemAliasId] : [],
    },
    skip: !itemAliasId,
  };
});

// 🟢🟢🟢 COMPUTED DATA
export const $isItemAliasLoading = atom((get) => {
  const data = get($remoteItemAliasDetail);
  return data?.isLoading ?? false;
});

export const $itemAliasError = atom((get) => {
  const data = get($remoteItemAliasDetail);
  return data?.error ?? null;
});

// 🟠🟠🟠 ACTION -> UPDATE item alias
export const $updateItemAlias = itemAliasUpdateAtom({
  onSuccess: (get) => {
    get($remoteItemAliasDetail).refetch?.();
  },
});
